import { CodeAPI } from 'api/codeAPI';
import downloadFileFromCloud from 'services/downloadFileFromCloud';
import { ICodesTable } from 'interfaces/Code/ICodesTable';
import { IIsciCode } from 'interfaces/IsciCode/IIsciCode';
import RESPONSE_CODES from 'constants/responseCodes';

const getCodeFile = (code: ICodesTable, isciCode: IIsciCode) => {
  return CodeAPI.getFileDownloadPath({
    creativeId: code.creative_id,
    codeId: code.id,
    isciCodeId: isciCode.id,
  }).then((response) => {
    if (response.status === RESPONSE_CODES.OK) {
      return downloadFileFromCloud(response.data.data.url);
    } else {
      throw new Error(response.data.error?.details);
    }
  });
};

export default getCodeFile;
